import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentUserSelector } from './AuthSelector';

const getSiteDataLayer = state => state.getIn(['analytics', 'siteDataLayer'], Immutable.Map());

export const getDataLayer = createSelector([getSiteDataLayer, currentUserSelector], (siteDataLayer, user) => {
  const userDataLayer = user ? {
    'bc.encodedUserId': user.get('encodedId')
  } : {};

  return siteDataLayer.merge(userDataLayer);
});

export default {
  getDataLayer
};



// WEBPACK FOOTER //
// ./app/selectors/AnalyticsSelector.js